<template>
<div>
    <div class="text-center" v-if="isLoggedIn && !userprofile.email_verified_at">
        <b-alert variant="warning" show>
            Your account is not activated yet, <router-link target="_blank" class="badge badge-warning" to="/accounts/verify">Activate it now</router-link>
        </b-alert>
    </div>
    <div class="text-center" v-if="isLoggedIn && userprofile.profile_completed == 'No'">
        <b-alert variant="warning" show>
            Your profile is not completed yet, <router-link target="_blank" class="badge badge-warning" to="/profile">Complete it now</router-link>
        </b-alert>
    </div>
</div>
</template>

<script>
export default {
    name: 'activation',
    computed: {
        userprofile: function () {
            return this.$store.getters.userprofile;
        },
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        }
    },
}
</script>
